<template>
  <div
    id="modalForm"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">設定時間</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <h4 class="col-md-2">起始時間：</h4>
              <DateSelect ref="startTime" class="col-md-12"></DateSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 class="col-md-2">結束時間：</h4>
              <DateSelect ref="endTime" class="col-md-12"></DateSelect>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            關閉
          </button>
          <button type="button" class="btn btn-secondary" @click="_confirmDate">
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelect from '../../components/tool/DateSelect'

export default {
  components: {
    DateSelect,
  },
  methods: {
    _openModal() {
      $('#modalForm').modal('show')
    },
    _close() {
      $('#modalForm').modal('hide')
    },
    _confirmDate() {
      // if(this._getDate().length === 0) {
      //   alert('時間區間不符合')
      //   return
      // }
      this.$emit('getDate', this._getDate())
      this._close()
    },
    _getDate() {
      let startTime = this.$refs.startTime.getDate()
      let endTime = this.$refs.endTime.getDate()
      // let isTimeCurrent = moment(startTime).isBefore(endTime)
      // if(!isTimeCurrent) return []
      return [startTime, endTime]
    },
  },
}
</script>
<style scoped>
.margin-input {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/driver/SetSuspensionTime.vue